import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SnackbarService } from './snackbar.service';

import { SnackbarComponent } from './snackbar.component';

@NgModule({
  imports: [
    CommonModule
  ],
  providers: [
    SnackbarService
  ],
  declarations: [
    SnackbarComponent
  ],
  exports: [
    SnackbarComponent
  ]
})
export class SnackbarModule { }
